module.exports = __webpack_public_path__ + "dee1546d9882f07b318cd8ada5a03368.svg";